import { Vendor } from "gen/vendors/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchVendors } from "features/api/search"
import { vendorFilterKey } from "hooks/filters/filterKeys"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export { vendorFilterKey }

export function useVendorFilter({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Pick<
  UseWebFilterProps<unknown>,
  "persistInUrl" | "initialSelectedOptions"
> = {}) {
  const { results, setQuery, loadNext } = useSearchVendors()

  const vendors = useMemo(() => {
    const res: Vendor[] = []
    for (const { vendor } of results) {
      if (!vendor) continue
      res.push(vendor)
    }
    return res
  }, [results])

  const { filter, selected: selectedVendorIds } = useIdFilter({
    key: vendorFilterKey,
    label: "Vendor",
    values: vendors,
    labelExtractor: (vendor) => vendor.name,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      })
    },
  })

  return { filter, selectedVendorIds }
}
